// ./01 - PROJETOS DEV/meu-controle-de-estoque/src/components/modals/EditProductModal.jsx

import React, { useState, useEffect } from 'react';

const EditProductModal = ({ isOpen, onClose, onSave, product, brands }) => {
    const [formState, setFormState] = useState({
        name: '',
        brand: '',
        category: '',
        code: '',
        cost: '',
        salePrice: '',
        initialQty: '',
        purchaseDate: '',
        expiry: ''
    });

    const [isSaving, setIsSaving] = useState(false);

    // Carrega os dados do produto quando o modal abre
    useEffect(() => {
        if (isOpen && product) {
            setFormState({
                name: product.name || '',
                brand: product.brand || '',
                category: product.category || '',
                code: product.code || '',
                cost: product.cost || '',
                salePrice: product.salePrice || '',
                initialQty: product.initialQty || '',
                purchaseDate: product.purchaseDate ? new Date(product.purchaseDate).toISOString().split('T')[0] : '',
                expiry: product.expiry ? new Date(product.expiry).toISOString().split('T')[0] : ''
            });
        }
    }, [isOpen, product]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSaving) return;
        setIsSaving(true);

        try {
            const updatedData = {
                ...formState,
                cost: parseFloat(formState.cost),
                salePrice: parseFloat(formState.salePrice),
                initialQty: parseInt(formState.initialQty),
                purchaseDate: formState.purchaseDate ? new Date(`${formState.purchaseDate}T12:00:00`) : null,
                expiry: formState.expiry ? new Date(`${formState.expiry}T12:00:00`) : null
            };
            
            await onSave(product.id, updatedData);
            onClose();
        } catch (error) {
            console.error("Erro ao atualizar produto:", error);
            alert("Erro ao salvar alterações.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen || !product) return null;

    return (
        <div className="modal-overlay z-50 flex items-center justify-center fixed inset-0 bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-2xl m-4 max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Editar Cadastro do Produto</h2>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="md:col-span-2">
                            <label className="form-label text-sm font-semibold">Nome do Produto</label>
                            <input name="name" value={formState.name} onChange={handleChange} type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-[#D7BFBD] focus:border-[#D7BFBD]" required />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Marca</label>
                            <select name="brand" value={formState.brand} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-[#D7BFBD] focus:border-[#D7BFBD]">
                                <option value="">Selecione uma marca</option>
                                {brands.map(b => <option key={b.id} value={b.name}>{b.name}</option>)}
                            </select>
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Categoria</label>
                            <input name="category" value={formState.category} onChange={handleChange} type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Preço de Custo (R$)</label>
                            <input name="cost" value={formState.cost} onChange={handleChange} type="number" step="0.01" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Preço de Venda (R$)</label>
                            <input name="salePrice" value={formState.salePrice} onChange={handleChange} type="number" step="0.01" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Quantidade Inicial</label>
                            <input name="initialQty" value={formState.initialQty} onChange={handleChange} type="number" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Data de Compra</label>
                            <input name="purchaseDate" value={formState.purchaseDate} onChange={handleChange} type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                        </div>

                        <div>
                            <label className="form-label text-sm font-semibold">Data de Validade</label>
                            <input name="expiry" value={formState.expiry} onChange={handleChange} type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                        </div>

                        {/* Código de Barras agora posicionado ao lado da Data de Validade */}
                        <div>
                            <label className="form-label text-sm font-semibold">Código de Barras (Opcional)</label>
                            <input name="code" value={formState.code} onChange={handleChange} type="text" placeholder="Ex: 789002..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-[#D7BFBD] focus:border-[#D7BFBD]" />
                        </div>
                    </div>

                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-6 border-t mt-6">
                        <button type="button" onClick={onClose} className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto">Cancelar</button>
                        <button type="submit" disabled={isSaving} className="custom-button py-2 px-6 font-semibold rounded-lg shadow-sm w-full sm:w-auto">
                            {isSaving ? 'Salvando...' : 'Salvar Alterações'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditProductModal;